import React from "react";
import { Tab } from "@mui/material";
import "./BrentoTab.scss";

const BrentoTab = (props) => {
  return <Tab {...props} disableRipple className="brento-tab" />;
};

export default BrentoTab;
